export default {
  getThisMonthStartTime () {
    let currentDate = new Date()
    let year = currentDate.getFullYear()
    let month = currentDate.getMonth()
    const start = new Date(year, month, 1, 0, 0, 0)
    return start
  },
  getThisMonthEndTime () {
    let currentDate = new Date()
    let year = currentDate.getFullYear()
    let month = currentDate.getMonth()
    const end = new Date(year, month + 1, 1, 0, 0, 0)
    return end
  },
  getDayStartTime () {
    let currentDate = new Date()
    let year = currentDate.getFullYear()
    let month = currentDate.getMonth()
    let day = currentDate.getDate()
    const start = new Date(year, month, day, 0, 0, 0)
    return start
  },
  getDayEndTime () {
    let currentDate = new Date()
    let year = currentDate.getFullYear()
    let month = currentDate.getMonth()
    let day = currentDate.getDate()
    const start = new Date(year, month, day + 1, 0, 0, 0)
    return start
  },
  getNDayTime (nDay) {
    let currentDate = new Date()
    let year = currentDate.getFullYear()
    let month = currentDate.getMonth()
    let day = currentDate.getDate()
    const time = new Date(year, month, day + nDay, 0, 0, 0)
    return time
  },
  getDateTimeStr (unixtime) {
    if (!unixtime) {
      return null
    }
    let localeDate = new Date(unixtime)
    let year = localeDate.getFullYear()
    let month = localeDate.getMonth() + 1
    let day = localeDate.getDate()
    let hours = localeDate.getHours()
    let minutes = localeDate.getMinutes()
    let seconds = localeDate.getSeconds()
    let dateText = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
    dateText += ' ' + (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
    return dateText
  },
  getDateTimeByUnixTime: function (time, format = '-') {
    if (!time) {
      return '无'
    }
    let unixtime = parseInt(time)

    let localeDate = new Date(unixtime)
    let year = localeDate.getFullYear()
    let month = localeDate.getMonth() + 1
    let day = localeDate.getDate()
    let hour = localeDate.getHours()
    let minutes = localeDate.getMinutes()
    let seconds = localeDate.getSeconds()
    let dateText = year + format + (month < 10 ? '0' + month : month) + format + (day < 10 ? '0' + day : day)
    dateText = dateText + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
    return dateText
  },
  getDateByUnixTime: function (time) {
    if (!time) {
      return '无'
    }
    let unixtime = parseInt(time)
    let localeDate = new Date(unixtime)
    let year = localeDate.getFullYear()
    let month = localeDate.getMonth() + 1
    let day = localeDate.getDate()
    let dateText = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
    return dateText
  }
}
